import { getModelConfig, resolveModelKey } from '@/config/model-registry';

const removeEmptyFields = (payload) => {
  Object.keys(payload).forEach((key) => {
    if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
      delete payload[key];
    }
  });
};

export function buildRemixGenerationParams({
  prompt,
  taskId,
  size,
  duration,
  modelName,
  modelKey,
  functionMode = 'editing',
  aspectRatioLabel,
  resolutionLabel,
  generationMode,
  outputCount,
  generateAudio,
  contextIrEnabled,
  seed,
  webSearch,
  inputAssets,
  tokenOverride,
  currentQualityOptions = [],
  selectedResolution,
  selectedModel,
  selectedModelConfig,
  currentDurationValue,
  turnstileToken,
} = {}) {
  const trimmedPrompt = String(prompt || '').trim();
  if (!trimmedPrompt) {
    return null;
  }

  const resolvedModelKey = resolveModelKey(modelKey || modelName || '') || selectedModel;
  const resolvedConfig = getModelConfig(resolvedModelKey) || selectedModelConfig;
  const resolvedModelName = resolvedConfig?.displayName || modelName || selectedModel;
  const currentResolution =
    currentQualityOptions.find((res) => res.id === selectedResolution)
    || currentQualityOptions[0];
  const resolvedSize = size || currentResolution?.apiSize;
  const resolvedDuration = resolvedConfig?.type === 'video'
    ? (duration || currentDurationValue)
    : undefined;

  const params = {
    prompt: trimmedPrompt,
    size: resolvedSize,
    modelName: resolvedModelName,
    modelKey: resolvedModelKey,
    quality: currentResolution?.label,
    aspectRatioLabel,
    resolutionLabel: resolutionLabel || currentResolution?.resolutionLabel,
    duration: resolvedDuration,
    functionMode,
    remixTaskId: taskId || undefined,
    mode: taskId ? 'remix' : undefined,
    inputAssets: Array.isArray(inputAssets) && inputAssets.length ? inputAssets : undefined,
    generationMode,
    outputCount,
    generateAudio,
    contextIrEnabled: resolvedModelKey.startsWith('minimax-h3') && generationMode !== 'unlimited' && contextIrEnabled === true,
    seed,
    webSearch,
    turnstileToken: tokenOverride || turnstileToken,
  };

  removeEmptyFields(params);

  return {
    trimmedPrompt,
    params,
  };
}
